import {
	ADD_AGENDA_FAIL,
	ADD_AGENDA_START,
	ADD_AGENDA_SUCCESS,
	ADD_STORICO_PRENOTAZIONE_FAIL,
	ADD_STORICO_PRENOTAZIONE_START,
	ADD_STORICO_PRENOTAZIONE_SUCCESS,
	CREATE_TAMPONE_FAIL,
	CREATE_TAMPONE_START,
	CREATE_TAMPONE_SUCCESS,
	GET_ALL_AGENDE_FAIL,
	GET_ALL_AGENDE_START,
	GET_ALL_AGENDE_SUCCESS,
	GET_INFO_PRENOTAZIONI_FAIL,
	GET_INFO_PRENOTAZIONI_START,
	GET_INFO_PRENOTAZIONI_SUCCESS,
	GET_PRENOTAZIONE_FAIL,
	GET_PRENOTAZIONE_START,
	GET_PRENOTAZIONE_SUCCESS,
	GET_STORICO_PRENOTAZIONE_FAIL,
	GET_STORICO_PRENOTAZIONE_START,
	GET_STORICO_PRENOTAZIONE_SUCCESS,
	GET_TAMPONE_BY_ID_FAIL,
	GET_TAMPONE_BY_ID_START,
	GET_TAMPONE_BY_ID_SUCCESS, GET_TAMPONI_BY_DAY_FAIL,
	GET_TAMPONI_BY_DAY_START, GET_TAMPONI_BY_DAY_SUCCESS,
	GET_TAMPONI_BY_MONTH_FAIL,
	GET_TAMPONI_BY_MONTH_START,
	GET_TAMPONI_BY_MONTH_SUCCESS,
	PRENOTA_TAMPONE_FAIL,
	PRENOTA_TAMPONE_START,
	PRENOTA_TAMPONE_SUCCESS, RESET_TAMPONI_DAY,
	SEARCH_PRENOTAZIONE_FAIL,
	SEARCH_PRENOTAZIONE_START,
	SEARCH_PRENOTAZIONE_SUCCESS,
	SEND_PDF_FAIL,
	SEND_PDF_START,
	SEND_PDF_SUCCESS,
	UPDATE_PRENOTAZIONE_FAIL,
	UPDATE_PRENOTAZIONE_START,
	UPDATE_PRENOTAZIONE_SUCCESS,
	UPDATE_TAMPONE_FAIL,
	UPDATE_TAMPONE_START,
	UPDATE_TAMPONE_SUCCESS
} from "./actions/ActionTypes";

export const initTamponiState = () => {
	return {
		tampone: {},
		loadingGetTampone: true,
		errorGetTampone: "",
		loadingUpdateTampone: true,
		errorUpdateTampone: "",
		loadingPrenotaTampone: true,
		errorPrenotaTampone: "",
		loadingGetPrenotazione: true,
		errorGetPrenotazione: "",
		prenotazione: {},
		loadingUpdatePrenotazione: true,
		errorUpdatePrenotazione: "",
		loadingAddTampone: true,
		errorAddTampone: "",
		
		loadingAddAgenda: true,
		errorAddAgenda: "",
		
		loadingGetAllAgende: true,
		errorGetAllAgende: "",
		agende: [],
		
		loadingGetStorico: true,
		errorGetStorico: "",
		storicoPrenotazioni: [],
		
		loadingAddStorico: true,
		errorAddStorico: "",
		
		infoPrenotazioni: {},
		loadingGetInfoPrenotazioni: true,
		errorGetInfoPrenotazioni: "",
		prenotazioneEffettuata: {},
		
		loadingSendPDF: true,
		errorSendPDF: "",
		
		searchedPrenotazioni: [],
		loadingSearchPrenotazioni: true,
		errorSearchPrenotazioni: "",
		
		loadingGetTamponiByMonth: true,
		errorGetTamponiByMonth: "",
		tamponiMonth: {},
		
		loadingGetTamponiByDay: true,
		errorGetTamponiByDay: "",
		tamponiDay: [],
		tamponiDayPayload: [],
	}
}

export const TAMPONI_INITIAL_STATE = {}

export const TamponiReducer = (state = TAMPONI_INITIAL_STATE, action) => {
	console.log(action);
	switch (action.type) {
		case GET_TAMPONE_BY_ID_START:
			return {
				...state,
				tampone: {},
				loadingGetTampone: true,
				errorGetTampone: "",
			}
		case GET_TAMPONE_BY_ID_SUCCESS:
			return {
				...state,
				tampone: action.payload,
				loadingGetTampone: false,
				errorGetTampone: "",
			}
		case GET_TAMPONE_BY_ID_FAIL:
			return {
				...state,
				tampone: {},
				loadingGetTampone: false,
				errorGetTampone: action.error,
			}
		case UPDATE_TAMPONE_START:
			return {
				...state,
				loadingUpdateTampone: true,
				errorUpdateTampone: "",
			}
		case UPDATE_TAMPONE_SUCCESS:
			return {
				...state,
				loadingUpdateTampone: false,
				errorUpdateTampone: "",
				tampone: action.payload
			}
		case UPDATE_TAMPONE_FAIL:
			return {
				...state,
				loadingUpdateTampone: false,
				errorUpdateTampone: action.error,
			}
		case PRENOTA_TAMPONE_START:
			return {
				...state,
				loadingPrenotaTampone: true,
				errorPrenotaTampone: "",
				prenotazioneEffettuata: {},
			}
		case PRENOTA_TAMPONE_SUCCESS:
			return {
				...state,
				loadingPrenotaTampone: false,
				errorPrenotaTampone: "",
				prenotazioneEffettuata: action.payload,
			}
		case PRENOTA_TAMPONE_FAIL:
			return {
				...state,
				loadingPrenotaTampone: false,
				errorPrenotaTampone: action.error,
				prenotazioneEffettuata: {},
			}
		case GET_PRENOTAZIONE_START:
			return {
				...state,
				loadingGetPrenotazione: true,
				errorGetPrenotazione: "",
				prenotazione: {},
			}
		case GET_PRENOTAZIONE_SUCCESS:
			return {
				...state,
				loadingGetPrenotazione: false,
				errorGetPrenotazione: "",
				prenotazione: action.payload,
			}
		case GET_PRENOTAZIONE_FAIL:
			return {
				...state,
				loadingGetPrenotazione: false,
				errorGetPrenotazione: "",
				prenotazione: action.error,
			}
		case UPDATE_PRENOTAZIONE_START:
			return {
				...state,
				loadingUpdatePrenotazione: true,
				errorUpdatePrenotazione: "",
			}
		case UPDATE_PRENOTAZIONE_SUCCESS:
			return {
				...state,
				loadingUpdatePrenotazione: false,
				errorUpdatePrenotazione: "",
			}
		case UPDATE_PRENOTAZIONE_FAIL:
			return {
				...state,
				loadingUpdatePrenotazione: false,
				errorUpdatePrenotazione: action.error,
			}
		case CREATE_TAMPONE_START:
			return {
				...state,
				loadingAddTampone: true,
				errorAddTampone: "",
			}
		case CREATE_TAMPONE_SUCCESS:
			return {
				...state,
				loadingAddTampone: false,
				errorAddTampone: "",
			}
		case CREATE_TAMPONE_FAIL:
			return {
				...state,
				loadingAddTampone: false,
				errorAddTampone: action.error,
			}
		case ADD_AGENDA_START:
			return {
				...state,
				loadingAddAgenda: true,
				errorAddAgenda: "",
			}
		case ADD_AGENDA_SUCCESS:
			return {
				...state,
				loadingAddAgenda: false,
				errorAddAgenda: "",
			}
		case ADD_AGENDA_FAIL:
			return {
				...state,
				loadingAddAgenda: false,
				errorAddAgenda: action.error,
			}
		case GET_ALL_AGENDE_START:
			return {
				...state,
				loadingGetAllAgende: true,
				errorGetAllAgende: "",
				agende: [],
			}
		case GET_ALL_AGENDE_SUCCESS:
			return {
				...state,
				loadingGetAllAgende: false,
				errorGetAllAgende: "",
				agende: action.payload,
			}
		case GET_ALL_AGENDE_FAIL:
			return {
				...state,
				loadingGetAllAgende: false,
				errorGetAllAgende: action.error,
				agende: [],
			}
		case GET_STORICO_PRENOTAZIONE_START:
			return {
				...state,
				loadingGetStorico: true,
				errorGetStorico: "",
				storicoPrenotazioni: [],
			}
		case GET_STORICO_PRENOTAZIONE_SUCCESS:
			return {
				...state,
				loadingGetStorico: false,
				errorGetStorico: "",
				storicoPrenotazioni: action.payload,
			}
		case GET_STORICO_PRENOTAZIONE_FAIL:
			return {
				...state,
				loadingGetStorico: false,
				errorGetStorico: action.error,
				storicoPrenotazioni: [],
			}
		case ADD_STORICO_PRENOTAZIONE_START:
			return {
				...state,
				loadingAddStorico: true,
				errorAddStorico: "",
			}
		case ADD_STORICO_PRENOTAZIONE_SUCCESS:
			return {
				...state,
				loadingAddStorico: false,
				errorAddStorico: "",
			}
		case ADD_STORICO_PRENOTAZIONE_FAIL:
			return {
				...state,
				loadingAddStorico: false,
				errorAddStorico: action.error,
			}
		case GET_INFO_PRENOTAZIONI_START:
			return {
				...state,
				infoPrenotazioni: {},
				loadingGetInfoPrenotazioni: true,
				errorGetInfoPrenotazioni: "",
			}
		case GET_INFO_PRENOTAZIONI_SUCCESS:
			return {
				...state,
				infoPrenotazioni: action.payload,
				loadingGetInfoPrenotazioni: false,
				errorGetInfoPrenotazioni: "",
			}
		case GET_INFO_PRENOTAZIONI_FAIL:
			return {
				...state,
				infoPrenotazioni: {},
				loadingGetInfoPrenotazioni: false,
				errorGetInfoPrenotazioni: action.error,
			}
		case SEND_PDF_START:
			return {
				...state,
				loadingSendPDF: true,
				errorSendPDF: "",
			}
		case SEND_PDF_SUCCESS:
			return {
				...state,
				loadingSendPDF: false,
				errorSendPDF: "",
			}
		case SEND_PDF_FAIL:
			return {
				...state,
				loadingSendPDF: false,
				errorSendPDF: action.payload,
			}
		case SEARCH_PRENOTAZIONE_START:
			return {
				...state,
				searchedPrenotazioni: [],
				loadingSearchPrenotazioni: true,
				errorSearchPrenotazioni: "",
			}
		case SEARCH_PRENOTAZIONE_SUCCESS:
			return {
				...state,
				searchedPrenotazioni: action.payload,
				loadingSearchPrenotazioni: false,
				errorSearchPrenotazioni: "",
			}
		case SEARCH_PRENOTAZIONE_FAIL:
			return {
				...state,
				searchedPrenotazioni: [],
				loadingSearchPrenotazioni: false,
				errorSearchPrenotazioni: action.error,
			}
		case GET_TAMPONI_BY_MONTH_START:
			return {
				...state,
				loadingGetTamponiByMonth: true,
				errorGetTamponiByMonth: "",
				tamponiMonth: {},
			}
		case GET_TAMPONI_BY_MONTH_SUCCESS:
			return {
				...state,
				loadingGetTamponiByMonth: false,
				errorGetTamponiByMonth: "",
				tamponiMonth: action.payload,
			}
		case GET_TAMPONI_BY_MONTH_FAIL:
			return {
				...state,
				loadingGetTamponiByMonth: false,
				errorGetTamponiByMonth: action.error,
				tamponiMonth: {},
			}
		case GET_TAMPONI_BY_DAY_START:
			return {
				...state,
				loadingGetTamponiByDay: true,
				errorGetTamponiByDay: "",
				tamponiDayPayload: [],
			}
		case GET_TAMPONI_BY_DAY_SUCCESS:
			let newState = [...state.tamponiDay, ...action.payload];
			return {
				...state,
				loadingGetTamponiByDay: false,
				errorGetTamponiByDay: "",
				tamponiDay: newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object))),
				tamponiDayPayload: action.payload,
			}
		case GET_TAMPONI_BY_DAY_FAIL:
			return {
				...state,
				loadingGetTamponiByDay: false,
				errorGetTamponiByDay: action.error,
				tamponiDay: [],
				tamponiDayPayload: [],
			}
		case RESET_TAMPONI_DAY: {
			return {
				...state,
				tamponiDay: [],
			}
		}
		
		default:
			return state;
	}
}
